import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { RemoveCollaboratorSuccess } from '@webapp/store/collaborator/action-creators';
import { REMOVE_COLLABORATOR_SUCCESS } from '@webapp/store/collaborator/actions';

export const trackCollaboratorRemoved = (action$: Observable<RemoveCollaboratorSuccess>) =>
  action$.pipe(
    ofType(REMOVE_COLLABORATOR_SUCCESS),
    map((action) => {
      if (window.analytics) {
        window.analytics.track('Collaborator Removed', {
          assetId: action.assetId,
          collaborator: {
            id: action.collaboratorId,
          }
        });
      }
    }),
    filter(() => false)
  )